module.exports = __webpack_public_path__ + "img/6.dd7d88fb.jpeg";